import { useQyGetDashboard } from "@factory/query/dashboard.query";
import "./dashboard.scss";
import { isTextAboutMoney } from "@shared/utility/is-text-about-money";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import { numberFormat } from "@shared/utility/formats/number-format";
import { DashboardModel } from "@shared/models/dashboard-model";
import { FaChartPie } from "react-icons/fa";
import DashboardCard from "@shared/ui/dashboard-card/dashboard-card";
import { Dropdown } from "primereact/dropdown";
import { useCallback, useState } from "react";
import { LabelValue } from "@shared/models/label-value.interface";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { Button } from "primereact/button";

/* eslint-disable-next-line */
export interface DashboardProps {}

export function Dashboard() {
  const { formatDateLocal } = useDateTimeContext();
  const [selectedDayFilter, setSelectedDayFilter] = useState("");
  const [dateFilter, setDateFilter] = useState([]);
  const dayFilterOption = [
    { label: "Today", value: "TODAY" },
    { label: "Yesterday", value: "YESTERDAY" },
    { label: "Week", value: "WEEK" },
    { label: "Month", value: "MONTH" },
  ] as LabelValue[];
  const getDateRange = useCallback(() => {
    if (dateFilter && !!dateFilter?.[0] && !!dateFilter?.[1]) {
      const start = formatDateLocal(
        dateFilter?.[0] ?? "",
        undefined,
        "yyyy-MM-dd"
      );
      const end = formatDateLocal(
        dateFilter?.[1] ?? "",
        undefined,
        "yyyy-MM-dd"
      );
      return {
        start,
        end,
      };
    }

    return null;
  }, [dateFilter]);

  const dateRange = getDateRange();
  const startDate = dateRange?.start;
  const endDate = dateRange?.end;

  const colorArray = [
    "bg-green-200",
    "bg-blue-200",
    "bg-teal-200",
    "bg-amber-200",
    "bg-lime-200",
    "bg-cyan-200",
    "bg-rose-200",
    "bg-fuchsia-200",
    "bg-purple-200",
  ];
  const { data } = useQyGetDashboard(
    "",
    undefined,
    selectedDayFilter,
    startDate,
    endDate
  );
  const dashboardData = data || [];

  const dayFilterElement = (
    <Dropdown
      value={selectedDayFilter}
      onChange={(e) => setSelectedDayFilter(e.value)}
      options={dayFilterOption}
      placeholder="Select a day filter"
      className="w-full"
    />
  );
  const dateRangeElement = (
    <Calendar
      value={dateFilter}
      onChange={(e) => setDateFilter(e.value as any)}
      selectionMode="range"
      readOnlyInput
      hideOnRangeSelection
      className="w-full"
    />
  );

  const dashboardArray = dashboardData.map((item, index) => {
    const itemValue = isTextAboutMoney(item.label ?? "")
      ? currencyFormat(item.value ?? 0)
      : numberFormat(item.value || 0);
    return new DashboardModel(
      item.label || "-",
      itemValue,
      <FaChartPie />,
      undefined,
      undefined,
      colorArray[index]
    );
  });

  // Local FUnction
  const handleClear = () => {
    setSelectedDayFilter("");
    setDateFilter([]);
  };

  return (
    <div id="Dashboard" className="dashboard p-7">
      <h1 className="mb-4">Dashboard</h1>
      <section>
        <h4 className="text-gray-500">Filters</h4>
        <section className="flex justify-between gap-4 mb-6">
          {dayFilterElement}
          {dateRangeElement}
          <Button
            className="block w-28"
            severity="secondary"
            outlined
            label="Clear"
            onClick={handleClear}
          />
        </section>
      </section>
      <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {dashboardArray.map((item, id) => (
          <DashboardCard key={id} model={item} />
        ))}
      </section>
    </div>
  );
}

export default Dashboard;
